/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Import_Group_Language_LabelInputs */

const en_subtitle_import_group_language_label = /** @type {(inputs: Subtitle_Import_Group_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group Language`)
};

const fr_subtitle_import_group_language_label = /** @type {(inputs: Subtitle_Import_Group_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langue du groupe`)
};

const de_subtitle_import_group_language_label = /** @type {(inputs: Subtitle_Import_Group_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppensprache`)
};

const it_subtitle_import_group_language_label = /** @type {(inputs: Subtitle_Import_Group_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lingua di gruppo`)
};

const ru_subtitle_import_group_language_label = /** @type {(inputs: Subtitle_Import_Group_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Групповой язык`)
};

const es_subtitle_import_group_language_label = /** @type {(inputs: Subtitle_Import_Group_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idioma grupal`)
};

const zh_cn2_subtitle_import_group_language_label = /** @type {(inputs: Subtitle_Import_Group_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`群体语言`)
};

const ja_subtitle_import_group_language_label = /** @type {(inputs: Subtitle_Import_Group_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループ言語`)
};

const hi_subtitle_import_group_language_label = /** @type {(inputs: Subtitle_Import_Group_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समूह भाषा`)
};

const pt_pt2_subtitle_import_group_language_label = /** @type {(inputs: Subtitle_Import_Group_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idioma do grupo`)
};

/**
* | output |
* | --- |
* | "Group Language" |
*
* @param {Subtitle_Import_Group_Language_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_import_group_language_label = /** @type {((inputs?: Subtitle_Import_Group_Language_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Import_Group_Language_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_import_group_language_label(inputs)
	if (locale === "de") return de_subtitle_import_group_language_label(inputs)
	if (locale === "it") return it_subtitle_import_group_language_label(inputs)
	if (locale === "ru") return ru_subtitle_import_group_language_label(inputs)
	if (locale === "es") return es_subtitle_import_group_language_label(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_import_group_language_label(inputs)
	if (locale === "ja") return ja_subtitle_import_group_language_label(inputs)
	if (locale === "hi") return hi_subtitle_import_group_language_label(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_import_group_language_label(inputs)
	return en_subtitle_import_group_language_label(inputs)
});